import { render, staticRenderFns } from "./spineAnimal.vue?vue&type=template&id=94a54ce2&scoped=true&"
import script from "./spineAnimal.vue?vue&type=script&lang=js&"
export * from "./spineAnimal.vue?vue&type=script&lang=js&"
import style0 from "./spineAnimal.vue?vue&type=style&index=0&id=94a54ce2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a54ce2",
  null
  
)

export default component.exports